import { PointCloudObject } from "@/object-cache";
import { useAppSelector } from "@/store/store-hooks";
import { GUID } from "@faro-lotv/foundation";
import { selectAncestor, selectIElement } from "@faro-lotv/project-source";
import { isEqual } from "es-toolkit";

/**
 * Like the eye icon of the project tree, but local to the wizard so the viewer visibility is untouched
 *
 * @param pointCloud The point cloud of the dataset
 * @returns the scans of the point cloud that are not sent, none if no scan is selected
 */
export function useIpxHiddenScans(pointCloud: PointCloudObject): GUID[] {
  return useAppSelector((state) => {
    const { totalScanCount, selectedScanIds } = state.ipxOrderMode;
    if (totalScanCount === undefined || !selectedScanIds.length) return [];
    const selected = new Set(selectedScanIds);
    return Object.keys(pointCloud.scanIdsToIndex ?? {}).filter((id) => {
      if (selected.has(id)) return false;
      const scan = selectIElement(id)(state);
      return !scan || !selectAncestor(scan, (el) => selected.has(el.id))(state);
    });
  }, isEqual);
}
